/** トップ等の横スクロール募集・特集カード（react-slick）の自動送り間隔（ms） */
export const HOME_LIST_SLICK_AUTOPLAY_MS = 7000;
